module.exports = __webpack_public_path__ + "static/media/44.128477a0.JPG";